"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.del = del;
exports.findByFlowInstId = findByFlowInstId;
exports.findById = findById;
exports.getList = getList;
exports.isEnableTenant = isEnableTenant;
exports.listAllTenant = listAllTenant;
exports.listAllTenantByPhone = listAllTenantByPhone;
exports.listAllTenantByUser = listAllTenantByUser;
exports.listAllTenantByUserName = listAllTenantByUserName;
exports.submit = submit;
exports.tenantIds = tenantIds;
exports.update = update;
var _request = _interopRequireDefault(require("@/utils/request"));
var _cloud = require("@/utils/cloud");
// 分页
function getList(query) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/sys-orgnization/list',
    method: 'POST',
    data: query
  });
}

// id 查询
function findById(id) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/sys-orgnization/' + id,
    method: 'get'
  });
}

// 流程实例 id 查询
function findByFlowInstId(id) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/sys-orgnization/findByFlowInstId/' + id,
    method: 'get'
  });
}

// 修改
function update(data) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/sys-orgnization',
    method: 'put',
    data: data
  });
}

// 保存
function add(data) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/sys-orgnization',
    method: 'post',
    data: data
  });
}

// 提交
function submit(data) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/sys-orgnization/submit',
    method: 'post',
    data: data
  });
}

// 删除
function del(id) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/sys-orgnization/del',
    method: 'delete',
    params: {
      id: id
    }
  });
}

// 分页
function listAllTenant() {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/sys-orgnization/listAllTenant',
    method: 'GET'
  });
}

// 根据登录用户名查询用户关联的所有组织
function listAllTenantByUserName(param) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/sys-orgnization/listAllTenantByUserName',
    method: 'GET',
    params: param
  });
}

// 根据手机号码查询用户关联的所有组织
function listAllTenantByPhone(param) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/sys-orgnization/listAllTenantByPhone',
    method: 'GET',
    params: param
  });
}

// 查询当前用户所属的组织
function tenantIds() {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/sys-orgnization/tenantIds',
    method: 'get'
  });
}

// 查询当前用户的下拉树结构
function listAllTenantByUser() {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/sys-orgnization/listAllTenantByUser',
    method: 'get'
  });
}

// 查询当前用户的下拉树结构
function isEnableTenant() {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/sys-orgnization/isEnableTenant',
    method: 'get'
  });
}